import React, { useState } from 'react';
import siteLogo from '../assets/logo.png';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineCloseCircle, AiFillCaretDown } from 'react-icons/ai';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSub, setIsOpenSub] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const toggleSubMenu = () => {
    setIsOpenSub(!isOpenSub);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  // const closeSub = () => {
  //   setIsOpenSub(false);
  // };
  return (
    <div>
      {/* WEB NAVBAR */}
      <div className="navbar web-nav">
        <div className="container">
          <div className="navbar-wrapper">
            <div className="logo-div">
              <Link to="/">
                <img src={siteLogo} alt="site-logo" />
              </Link>
            </div>
            <div className="nav-listings">
              <ul className="ul-nav">
                <Link to="/">
                  <li>Home</li>
                </Link>
                <li className="services-dropdown">
                  Services
                  <div className="submenu-wrapper">
                    <ul className="submenu">
                      <Link to="/services/algo-trading">
                        <li>Algo Trading</li>
                      </Link>
                      <Link to="/services/backtesting">
                        <li>Backtest</li>
                      </Link>
                      <Link to="/services/customised-solution">
                        <li>Customised Solution</li>
                      </Link>
                    </ul>
                  </div>
                </li>
                <Link to="/projects">
                  <li>Projects Portfolio</li>
                </Link>
                {/* <Link to="/team">
                  <li>Team</li>
                </Link> */}
              </ul>
            </div>
            <div className="nav-contact">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* MOBILE NAVBAR */}
      <div className="navbar mobile-nav">
        <div className="container">
          <div className="navbar-wrapper">
            <div className="logo-div">
              <Link to="/">
                <img src={siteLogo} alt="site-logo" />
              </Link>
            </div>
            <div className="hamburger" onClick={toggleNavbar}>
              {isOpen ? <AiOutlineCloseCircle /> : <GiHamburgerMenu />}
            </div>
          </div>
        </div>
        <div className={`nav-listings-mobile ${isOpen ? 'open' : ''}`}>
          <ul className="ul-nav">
            <Link to="/" onClick={closeNavbar}>
              <li>Home</li>
            </Link>
            <li onClick={toggleSubMenu} className="services-dropdown">
              <div className="wrap-submenu">
                Services <AiFillCaretDown />
              </div>

              <div
                className={`submenu-wrapper-mob ${isOpenSub ? 'openSub' : ''}`}
              >
                <ul className="submenu">
                  <Link to="/services/algo-trading" onClick={closeNavbar}>
                    <li>Algo Trading</li>
                  </Link>
                  <Link to="/services/backtesting" onClick={closeNavbar}>
                    <li>Backtest</li>
                  </Link>
                  <Link
                    to="/services/customised-solution"
                    onClick={closeNavbar}
                  >
                    <li>Customised Solution</li>
                  </Link>
                </ul>
              </div>
            </li>
            <Link to="/projects" onClick={closeNavbar}>
              <li>Projects Portfolio</li>
            </Link>
            {/* <Link to="/team" onClick={closeNavbar}>
              <li>Team</li>
            </Link> */}
            <Link to="/contact" onClick={closeNavbar}>
              <li>Contact Us</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
